import React from 'react';
import { arrayOf, bool, func, shape } from 'prop-types';
import { Popover } from '@mui/material';

// Components
import NotificationCenter from './NotificationCenter';

const DesktopNavNotifications = ({ notificationButtonAnchor, open, setOpen, notifications }) => (
  <Popover
    anchorEl={notificationButtonAnchor}
    anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
    disableScrollLock
    onClose={() => setOpen(false)}
    open={open}
    sx={{ zIndex: 1100 }}
    transformOrigin={{ horizontal: 'left', vertical: 'top' }}
  >
    <NotificationCenter notifications={notifications} />
  </Popover>
);

DesktopNavNotifications.propTypes = {
  notificationButtonAnchor: shape({}),
  notifications: arrayOf(shape({})),
  open: bool.isRequired,
  setOpen: func.isRequired,
};

DesktopNavNotifications.defaultProps = {
  notificationButtonAnchor: null,
  notifications: [],
};

export default DesktopNavNotifications;
